import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {CircularProgress} from '@material-ui/core';
import localforage from 'localforage';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
  },
  container: {
    position: 'absolute',
    bottom: '50%',
    left: '50%',
    marginLeft: -40,
  },
  bottom: {
    color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  top: {
    color: '#1a90ff',
    animationDuration: '550ms',
    position: 'absolute',
    left: 0,
  },
  circle: {
    strokeLinecap: 'round',
  },
}));
const App = (props) => {
  const classes = useStyles();

  const history = useHistory();
  useEffect(() => {
    history.push('/maps');
    // localforage.getItem('token').then((response) => {
    //   if (response) {
    //     history.push('/maps');
    //   } else {
    //     history.push('/maps');
    //   }
    // });
  }, [history]);

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <CircularProgress variant="determinate" className={classes.bottom} size={80} thickness={4} {...props} value={100} />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          className={classes.top}
          classes={{
            circle: classes.circle,
          }}
          size={80}
          thickness={4}
          {...props}
        />
      </div>
    </div>
  );
};

export default App;
